// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__9cSZs","visible":"Title_visible__EExLg","positioner":"Title_positioner__YWoRG","subTitle":"Title_subTitle__42KcN"};